import React, { useEffect, useState } from "react";
import Logo3D from "./Logo3D";

/**
 * Splash3D — full-screen brand splash on first app load. Shows the COMBINED
 * mark (all three sister companies together) as a full-color panel spinning in
 * 3D, over a solid white backdrop, with "Loading..." beneath. Fades out after
 * a minimum duration.
 *
 * Solid (opaque) background so nothing behind it (e.g. a page spinner) shows
 * through.
 *
 * Props:
 *   minDurationMs  default 1600
 *   onDone         called after fade-out
 */

const Splash3D = ({ minDurationMs = 1600, onDone }) => {
  const [phase, setPhase] = useState("in");

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("out"), minDurationMs);
    return () => clearTimeout(t1);
  }, [minDurationMs]);

  useEffect(() => {
    if (phase !== "out") return undefined;
    const t2 = setTimeout(() => {
      if (onDone) onDone();
    }, 480);
    return () => clearTimeout(t2);
  }, [phase, onDone]);

  return (
    <div
      role="status"
      aria-label="Loading"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 13000,
        background: "var(--ssw-surface, #ffffff)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 22,
        opacity: phase === "out" ? 0 : 1,
        transition: "opacity 0.48s ease",
        pointerEvents: phase === "out" ? "none" : "auto",
      }}
    >
      <Logo3D company="combined" size={300} secPerTurn={9} />

      <span
        style={{
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "var(--ssw-ink-blue, #16447a)",
          fontFamily: "'Inter', -apple-system, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        Loading...
      </span>
    </div>
  );
};

export default Splash3D;
